/**
 * Variables Globales para Fastco
 */

export const Globals = {
	idTag: '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953afe995afaca9066a9094717e67ae254c5e7188922dc935bd3746720b5ac1d5444256853a295dd97523e5ff0952df96d26e4a034e9a028d50b292b35f75f9ee7a8d61a102d055f753d8891a6d8821ad581',
	libraries: {
		dal: 'https://ws.walmeric.com/static/dft/dist/v1/dal.js',
		dcl: 'https://ws.walmeric.com/static/dft/dist/v2/dcl.js?idTag=29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953afe995afaca9066a9094717e67ae254c5e7188922dc935bd3746720b5ac1d5444256853a295dd97523e5ff0952df96d26e4a034e9a028d50b292b35f75f9ee7a8d61a102d055f753d8891a6d8821ad581',
	},

	tagVisit: {
		win: 'https://t.womtp.com/js/otg.min.js?idtag=09446dc7b52d37c53cf68b2cab65cecb',
	},
};
